import { INSPIRATION } from "../content/inspiration";
import { t } from "../i18n/dict";
import { langFromPath, localePath } from "../i18n/lang";
import { Page } from "../layout/Page";
import { Card } from "../ui/Card";
import { Reveal } from "../ui/Reveal";
import { Section } from "../ui/Section";

/**
 * The old site's `/inspiration` (and `/inspiration-HI`, which redirects to
 * `/hi/inspiration`): the three Sadguru successors, each linking to its full
 * biography, then the two living saints, each linking out to Facebook.
 */
export function InspirationPage() {
  const { lang } = langFromPath(window.location.pathname);

  return (
    <Page title="Inspiration" heading="Inspiration">
      <Section title={INSPIRATION.heading}>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {INSPIRATION.cards.map((card) => (
            <Reveal key={card.slug}>
              <Card
                title={card.name[lang]}
                image={{ src: card.portrait.src, alt: card.portrait.alt }}
                imageAspect="portrait"
                cta={{
                  label: t(lang, "knowMore"),
                  href: localePath(card.href, lang),
                }}
              >
                <p>{card.blurb[lang]}</p>
              </Card>
            </Reveal>
          ))}
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-2">
          {INSPIRATION.livingSaints.map((saint) => (
            <Reveal key={saint.href}>
              <Card
                title={saint.name[lang]}
                image={{ src: saint.portrait.src, alt: saint.portrait.alt }}
                cta={{
                  label: t(lang, "knowMore"),
                  href: saint.href,
                  external: true,
                }}
              >
                <p>{saint.blurb[lang]}</p>
              </Card>
            </Reveal>
          ))}
        </div>
      </Section>
    </Page>
  );
}
